import {Box, Typography} from '@mui/material';
import {Key} from 'react';
import Chip from '@jobseeker/lotus/elements/Chip';
import {CrossWhite} from '@jobseeker/lotus/icons';
import {Image} from '@jobseeker/lotus/components/Image';
import {optionsMap} from './utils';
import {useRouter} from 'next/router';

const Component = ({items, onDelete, ...props}: any) => {
  // const onDelete = value => {
  //   if (props.onDelete) {
  //     const option = optionsMap[value.key].find(o => o.value == value.value);
  //     console.log(option, value);
  //     props.onDelete(option);
  //   }
  // };
  const router = useRouter();
  const pathname = router.asPath;
  const isAISearchRoute = pathname.startsWith('/ai-search');

  return (
    <Box
      display={'flex'}
      justifyContent={'space-between'}
      flexWrap={'nowrap'}
      alignItems={'center'}
    >
      <Box
        sx={{
          maxWidth: {xxs: 'calc(100vw - 0px)', md: 'calc(100% - 75px)'},
          // minHeight: 'fit-content',
          transition: 'all ease 0.3',
          display: 'flex',
          // flexWrap: 'wrap',
          overflow: 'scroll',
          scrollbarWidth: 'none',
          gap: 1,
        }}
      >
        {/* {JSON.stringify(appliedFilters)} */}
        {items
          .filter((f: any) => !!f.label)
          .map((f: {label: string}, i: Key) => (
            <Chip
              deleteIcon={
                <Image
                  src={CrossWhite}
                  alt={'Close Icon'}
                  width={13}
                  height={13}
                  // onClick={props.onDismiss}
                  objectFit="cover"
                  style={{cursor: 'pointer'}}
                />
              }
              key={`filterchip-filter-${i}`}
              label={f.label}
              // variant="outlined"
              onClick={() => onDelete(f)}
              onDelete={() => onDelete(f)}
            />
          ))}
      </Box>
      {!!items.length && props.onClear && !isAISearchRoute && (
        <Typography
          sx={{cursor: 'pointer'}}
          width={'150px'}
          textAlign={'right'}
          onClick={props.onClear}
          variant="subtitle3"
          color={'secondary'}
        >
          Clear Filter
        </Typography>
      )}
    </Box>
  );
};

export default Component;
